import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import FloatingButtons from "@/components/FloatingButtons";

const PRIVACY = {
  title: "Política de Privacidad",
  updated: "Actualizada: Enero 2026",
  sections: [
    {
      h: "Introducción",
      p: "En Great Solutions US respetamos tu privacidad. Esta política explica qué información recopilamos, cómo la usamos y qué derechos tienes sobre ella.",
    },
    {
      h: "Información que recopilamos",
      p: "Cuando usas nuestro sitio web o solicitas nuestros servicios podemos recopilar: nombre, email, teléfono, dirección, información fiscal necesaria para prestar el servicio contratado, y mensajes que nos envías por el formulario de contacto o el chat.",
    },
    {
      h: "Cómo usamos tu información",
      p: "Usamos tus datos exclusivamente para: prestar los servicios que solicitas, comunicarnos contigo, cumplir con obligaciones legales del IRS y otras autoridades, mejorar nuestro servicio, y enviarte información relevante (solo si has aceptado recibir comunicaciones).",
    },
    {
      h: "Confidencialidad",
      p: "Toda la información compartida con Great Solutions US se maneja de forma confidencial. Cumplimos con los estándares del IRS y de la industria en el manejo de datos sensibles. No vendemos ni cedemos tu información a terceros.",
    },
    {
      h: "Cookies y analítica",
      p: "Podemos usar cookies para mejorar tu experiencia en el sitio y para analítica (Google Analytics). Puedes desactivar las cookies desde tu navegador.",
    },
    {
      h: "Tus derechos",
      p: "Puedes solicitar acceso, corrección o eliminación de tus datos personales en cualquier momento escribiendo a info@greatsolutionsus.com.",
    },
    {
      h: "Contacto",
      p: "Para cualquier consulta sobre esta política escríbenos a info@greatsolutionsus.com o llámanos al 786-704-1823.",
    },
  ],
};

const TERMS = {
  title: "Términos y Condiciones",
  updated: "Actualizados: Enero 2026",
  sections: [
    {
      h: "Aceptación",
      p: "Al usar el sitio greatsolutionsus.com y contratar nuestros servicios aceptas los siguientes términos.",
    },
    {
      h: "Servicios profesionales",
      p: "Great Solutions US ofrece servicios de preparación de impuestos (IRS Certified), tramitación de ITIN (Certifying Acceptance Agent), constitución de LLC y entidades comerciales, contabilidad, notarizaciones (Notary Public FL), asistencia con formularios migratorios y asesoría en seguros.",
    },
    {
      h: "Servicios de asistencia migratoria",
      p: "IMPORTANTE: Great Solutions US NO es un despacho jurídico y NO ofrece asesoría legal migratoria ni representa clientes ante USCIS, tribunales u otras autoridades. Nuestros servicios se limitan a la preparación y llenado de formularios migratorios conforme a la información que el cliente provee. Para asesoría legal o representación consulta un abogado autorizado.",
    },
    {
      h: "Precisión de la información",
      p: "El cliente es responsable de proporcionar información veraz, completa y actualizada. Great Solutions US no se hace responsable de errores, sanciones o consecuencias derivadas de información incorrecta o incompleta proporcionada por el cliente.",
    },
    {
      h: "Honorarios",
      p: "Los honorarios se cotizan según el servicio contratado y se comunican con transparencia antes de iniciar el trabajo. Los honorarios pagados por servicios prestados no son reembolsables una vez completado el trabajo.",
    },
    {
      h: "Confidencialidad profesional",
      p: "Mantenemos absoluta confidencialidad sobre la información compartida por nuestros clientes, en cumplimiento con estándares del IRS y de la profesión.",
    },
    {
      h: "Limitación de responsabilidad",
      p: "Great Solutions US brinda servicios profesionales con la debida diligencia, pero no garantiza resultados específicos (por ejemplo, montos de reembolso, aprobación de trámites por autoridades, etc.), ya que estos dependen de factores fuera de nuestro control.",
    },
    {
      h: "Modificaciones",
      p: "Podemos modificar estos términos en cualquier momento. Los cambios entran en vigor al publicarse en esta página.",
    },
    {
      h: "Ley aplicable",
      p: "Estos términos se rigen por las leyes del estado de Florida, Estados Unidos.",
    },
  ],
};

export default function LegalPage({ type }) {
  const doc = type === "privacy" ? PRIVACY : TERMS;

  return (
    <div className="min-h-screen bg-white" data-testid={`legal-${type}`}>
      <Navbar />
      <main className="pt-32 pb-20">
        <article className="max-w-3xl mx-auto px-6 lg:px-10">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-[#475569] hover:text-[#0B2D5C] mb-8">
            <ArrowLeft size={16} />
            Volver al inicio
          </Link>

          <div className="text-xs font-semibold text-[#0B2D5C] tracking-[0.2em] uppercase mb-3">
            Documento legal
          </div>
          <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#0f172a] mb-2">
            {doc.title}
          </h1>
          <p className="text-sm text-[#475569] mb-12">{doc.updated}</p>

          <div className="space-y-8">
            {doc.sections.map((s, i) => (
              <div key={i}>
                <h2 className="font-display text-xl font-semibold text-[#0f172a] mb-3">{s.h}</h2>
                <p className="text-[#334155] leading-relaxed">{s.p}</p>
              </div>
            ))}
          </div>
        </article>
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
